import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const sanitiseUserSkills = ({id, acquired, expired}) => ({
    id: Number(id),
    acquired: acquired && new Date(acquired),
    expired: expired && new Date(expired),
});

const countAcquiredSkills = (userSkills) => userSkills && userSkills.reduce((total, entry) => ((!!entry.expired && Date.parse(entry.expired) < Date.now()) ? total : total + 1 ), 0);

const sanitise = ({userId, complianceId, skillAcquired, userSkills, ...rest}) => ({
    userId: Number(userId),
    complianceId: Number(complianceId),
    skillTotal: rest.skills.length,
    skillAcquired: countAcquiredSkills(userSkills),
    userSkills: userSkills && userSkills.map(sanitiseUserSkills),
    ...rest
});

class UserComplianceStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: false,
            data: [],
        };
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getByUser(targetUserId) {
        return this.getState().data.filter(({userId}) => userId === targetUserId);
    }

    reduce(state, action) {
        let index;
        switch (action.type) {
            case ActionTypes.USER_COMPLIANCE_LIST_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.USER_COMPLIANCE_LIST_SUCCESS:
                return {data: updateData(state.data, action.data.map(sanitise), action.payload), isFetching: false};

            case ActionTypes.USER_COMPLIANCE_LIST_FAILURE:
                return {...state, isFetching: false};

            case ActionTypes.USER_COMPLIANCE_ADD_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.USER_COMPLIANCE_ADD_SUCCESS:
                return {...state, data: replaceData(state.data, action.data), isFetching: false};

            case ActionTypes.USER_COMPLIANCE_ADD_FAILURE:
                return {...state, isFetching: false};

            case ActionTypes.USER_COMPLIANCE_REMOVE_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.USER_COMPLIANCE_REMOVE_SUCCESS:
                return {...state, data: removeData(state.data, action.payload), isFetching: false};

            case ActionTypes.USER_COMPLIANCE_REMOVE_FAILURE:
                return {...state, isFetching: false};

            default:
                return state;
        }
    }
}

const updateData = (current, data = [], {userId, complianceId} = {}) => {
    if (!data.length && !userId && !complianceId) { return current; } // no change
    let result = [];
    if (userId || complianceId) {
        result = current.filter(r => (r && (r.userId !== userId) && (r.complianceId !== complianceId)) );
    }
    return result.concat(...data);
};

const removeData = (current, {userId: uid, complianceId: cid}) => current.filter(data => (uid !== data.userId || cid !== data.complianceId));

const replaceData = (current, data) => {
    if (!data || !data.userId || !data.complianceId) { return current; }
    return removeData(current, data).concat(data);
};

export default new UserComplianceStore(Dispatcher);
